import { useFormContext, useWatch } from 'react-hook-form';

import { validateWhitespacesAsEmpty } from '@xemplo/common-util';
import { ChangeTaskTypes } from '@xemplo/gp-types';
import { TextAreaRhf } from '@xemplo/text-area';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export const Notes = () => {
  const { control } = useFormContext<FormFields>();

  const changeTask = useWatch({ control, name: 'changeTask' });
  const isPayInstruction = changeTask === ChangeTaskTypes.PAY_INSTRUCTION;

  return (
    <S.FormLabel>
      <div>
        {isPayInstruction ? (
          'Instructions'
        ) : (
          <>
            Notes <S.OptionalLabel>(optional)</S.OptionalLabel>
          </>
        )}
      </div>
      <TextAreaRhf
        placeholder="Enter notes"
        aria-label="Notes field"
        name="notes"
        stretch
        rows={4}
        rules={{
          required: isPayInstruction ? 'This field is required' : false,
          maxLength: {
            value: 2048,
            message: 'Must be less than 2048 characters',
          },
          validate: (value) => {
            return isPayInstruction ? validateWhitespacesAsEmpty(value) : true;
          },
        }}
      />
    </S.FormLabel>
  );
};
